export const translations = {
  en: {
    pharmacyInput: {
      noResults: 'No results found',
      closePharmacies: 'Below are some pharmacies near you',
    },
  },
};
